import React from 'react'

import * as S from './styles'

export const Separator = () => {
  return <S.Container />
}
